import { getCurrentLocale } from '@/i18n';
import { FileUploadBeforeSendEvent } from 'primevue/fileupload';
import { useUserInfo } from '@/modules/user/useUserInfo';

let tokenRequest: string | undefined;

export const getUsersByDept = (department: string, users: Record<string, unknown>[]) => {
  const usersByDept = users?.find((user) => {
    return department === user?.displayName;
  });

  if (usersByDept?.members && Array.isArray(usersByDept.members)) {
    return usersByDept.members.map((member) => {
      return {
        label: `${member.givenName} ${member.surname}`,
        email: member.mail,
        hide: false
      };
    });
  }

  return [];
};

export const handleSelectFile = async () => {
  tokenRequest = await useUserInfo().getToken();
};

export const handleBeforeSendImage = (event: FileUploadBeforeSendEvent) => {
  event.xhr.setRequestHeader('Authorization', 'Bearer ' + tokenRequest);
  event.xhr.setRequestHeader('Accept-Language', getCurrentLocale());
};

export const isEmptyValue = (object: object) => {
  if (!object) {
    return;
  }
  const isEmpty = Object.entries(object).find((data) => {
    const value = data[1];
    return value;
  });
  return !!isEmpty;
};
